import { FC } from 'react';
import { PageNames } from 'shared/constants/appConstants';
import { TableHeaderProvider } from 'shared/components/tableHeader/TableHeaderContext';
import PageHeader from 'shared/components/PageHeader';
import { Container } from 'reactstrap';
import ColoredTabs from 'shared/components/tabs/ColoredTabs';
import InfoBanner from 'shared/components/InfoBanner/InfoBanner';
import GovernanceTagsTable from '../table/GovernanceTagsTableController.tsx';
import { GovernanceTagsProvider } from '../../contexts/governanceTagsContext';
import { useGovernanceTags } from '../../hooks/useGovernanceTags';
import GovernanceTagsMetricBlocks from './GovernanceTagsMetricBlock';
import { ReactComponent as TagAnalyzerIcon } from '../../assets/tagAnalyzerIcon.svg';
import { GovernanceTagsProcessingProvider } from '../../contexts/governanceTagsProcessingContext.tsx';
import { useRootStore } from 'app/contexts/RootStoreContext';
import UsersStore from 'users/store/usersStore';

import styles from './GovernanceTagsExplorer.module.scss';

interface IRootStoreContext {
  usersStore: UsersStore;
}

const TABS = [
  { id: 0, name: 'Resource Virtual Tags' },
  { id: 1, name: 'Tags Analyzer' },
];

const ResourceVirtualTagsTab: FC = () => {
  const { metrics, isLoadingMetrics } = useGovernanceTags();
  const rootStore = useRootStore() as IRootStoreContext;
  const { usersStore } = rootStore;
  const { currDispUserCloudAccountType } = usersStore;

  return (
    <>
      <InfoBanner
        className={styles.infoBanner}
        closable={false}
        title="On this page"
        text={
          <>
            &#8226; The cloud resources that are have no native cloud provider tags.
            <br />
            &#8226; The cloud resources tagged with Umbrella Virtual Tags (vTags) for improved viewing and analysis.
          </>
        }
      />
      <GovernanceTagsMetricBlocks
        isLoadingMetricData={isLoadingMetrics}
        metrics={metrics}
        currDispUserCloudAccountType={currDispUserCloudAccountType}
      />
      <GovernanceTagsTable />
    </>
  );
};

const TagsAnalyzerTab: FC = () => {
  return (
    <div className={styles.placeholderTab}>
      <TagAnalyzerIcon />
      <p className={styles.emptyStateText}>Coming soon!</p>
    </div>
  );
};

const GovernanceTagsContent: FC = () => {
  return (
    <TableHeaderProvider>
      <Container>
        <PageHeader title={PageNames.GOVERNANCE_TAGS_EXPLORER} showDate />
        <ColoredTabs
          arrOfNavItems={TABS}
          defaultAccountIndex={0}
          className={styles.tabsContainer}
          staticInfo={null}
          selectedIndex={null}
        >
          <ResourceVirtualTagsTab />
          <TagsAnalyzerTab />
        </ColoredTabs>
      </Container>
    </TableHeaderProvider>
  );
};

const GovernanceTagsExplorer: FC = () => (
  <GovernanceTagsProvider>
    <GovernanceTagsProcessingProvider>
      <GovernanceTagsContent />
    </GovernanceTagsProcessingProvider>
  </GovernanceTagsProvider>
);

export default GovernanceTagsExplorer;
